import useCrudTable from "../../../../hooks/useCrudTable";
import { useTranslatedColumns } from "../../../general/modules/commons/tableTranslation/translatedColumns";
import { LogTableColumns } from "../../domain/columns/logTableColumns";
import { useParams } from "react-router-dom";
import { logSchema } from "../../domain/schemas/logSchema";
import { CustomFilters } from "../../../general/crudGraphql/domain/models/graphqlModel";
import { useMemo } from "react";

export const EntityLogPage = () => {
  const { filters } = useParams();

  const translatedColumns = useTranslatedColumns(LogTableColumns);

  const decodedFilters = useMemo(() => {
    if (!filters) return undefined;
    return JSON.parse(decodeURIComponent(filters)) as CustomFilters;
  }, [filters]);

  const crud = useCrudTable({
    prefix: "logs",
    entity: "ActivityInput",
    columns: translatedColumns,
    schema: logSchema,
    filters: decodedFilters,
    defaultSorting: [
      {
        id: "created_at",
        desc: true,
      },
    ],
  });
  return crud.table;
};
